module.exports = __webpack_public_path__ + "img/IMG_9512_L_BlackMatted.3208aa9f.jpg";